import { render, staticRenderFns } from "./AnswerTrend.vue?vue&type=template&id=1ac970c9"
import script from "./AnswerTrend.vue?vue&type=script&lang=ts"
export * from "./AnswerTrend.vue?vue&type=script&lang=ts"
import style0 from "./AnswerTrend.vue?vue&type=style&index=0&id=1ac970c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports